import React from 'react'
import secvicesMan from '../../assets/approachMain/servicesman.png'

const OurServices = () => {

  return (
    <div className='bg-portfolio-bg lg:min-h-[100vh] overflow-x-hidden px-6 md:px-12 pt-12 w-full bg-cover bg-center text-[#fff]'>
        <h1 className='text-5xl text-center font-mosk600 ' >Our Services</h1>

        <div className=' hidden md:flex flex-col items-center gap-6 py-12 lg:pb-0  text-sm'>


          <div className='flex gap-8' >
            
            
          </div>

          <div className='flex gap-20 ' >
            <div data-aos="zoom-in" data-aos-duration="1000" className='bg-[#224ab3] w-[105px] h-[105px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center' >Corporate <br /> Events</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1000" className='bg-[#f03359] w-[105px] h-[105px] flex items-center justify-center rounded-full drop-shadow-lg'>
                <p className=' text-center'>Corporate <br /> Gifting</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1000" className='bg-[#224ab3] w-[105px] h-[105px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Product <br /> Launches</p>
            </div>
          </div>

          <div className='flex gap-16'>
            <div data-aos="zoom-in" data-aos-duration="1150" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Annual Sales <br /> Meet</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1150" className='bg-[#224ab3] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Leadership <br /> Experiential Tour</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1150" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Exhibitions</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1150" className='bg-[#224ab3] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Rewards and <br /> recognition</p>
            </div>
          </div>

          <div className='flex flex-wrap gap-12 lg:gap-20'>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Artist <br /> Management</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#224ab3] w-[130px] h-[130px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Branding and <br /> Communications</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#224ab3] w-[60px] h-[60px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>MICE</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Office <br /> Launch</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Virtual <br /> Events</p>
            </div>
          </div>

          <div className='hidden lg:flex flex-wrap gap-8 '>
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center' >Product <br /> Launches</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Corporate <br /> Films</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Sustainable <br /> Solutions</p>
            </div>
            <img className='h-[200px] hidden lg:block' src={secvicesMan } alt="" />
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Tech <br /> Integration</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#f03359] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Employee <br /> Engagements</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1450" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
                <p className=' text-center'>Annual <br /> Celebrations</p>
            </div>
          </div>

          <div  className='flex flex-wrap gap-24 lg:hidden'>
            <div data-aos="zoom-in" data-aos-duration="1550" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center' >Product <br /> Launches</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1550" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Corporate <br /> Films</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1550" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Sustainable <br /> Solutions</p>
            </div>
          </div>

          <div  className='flex gap-8 lg:hidden flex-wrap'>
            <div data-aos="zoom-in" data-aos-duration="1650" className='bg-[#224ab3] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Tech <br /> Integration</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1650" className='bg-[#f03359] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Employee <br /> Engagements</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1650" className='bg-[#f03359] w-[100px] h-[100px] flex items-center justify-center rounded-full drop-shadow-lg'>
                <p className=' text-center'>Annual <br /> Celebrations</p>
            </div>
          </div>


          
        </div>


        {/* mobile */}

        <div className=' flex md:hidden flex-col items-center  gap-6 py-12 lg:pb-0  text-sm'>


          <div className='flex gap-4 ' >
            <div data-aos="zoom-in" data-aos-duration="1100" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center' >Corporate <br /> Events</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1100" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
                <p className=' text-center'>Corporate <br /> Gifting</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1100" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Product <br /> Launches</p>
            </div>
          </div>

          <div className='flex gap-4'>
            <div data-aos="zoom-in" data-aos-duration="1200" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Annual <br /> Sales Meet</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1200" className='bg-[#224ab3] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Leadership <br /> Experiential Tour</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1200" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Artist <br /> Management</p>
            </div>
          </div>

          <div className='flex  gap-4 '>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Exhibitions</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#224ab3] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Rewards and <br /> recognition</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1300" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Corporate <br /> Films</p>
            </div>
          </div>

          <div className='flex  gap-4'>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Office <br /> Launch</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#224ab3] w-[60px] h-[60px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>MICE</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Virtual <br /> Events</p>
            </div>
           
          </div>

          <div className='flex  gap-4 '>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center' >Product <br /> Launches</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Sustainable <br /> Solutions</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1400" className='bg-[#224ab3] w-[130px] h-[130px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Branding and <br /> Communications</p>
            </div>
          </div>

          <div className='flex  gap-4 '>
            <div data-aos="zoom-in" data-aos-duration="1500" className='bg-[#224ab3] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Tech <br /> Integration</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1500" className='bg-[#f03359] w-[120px] h-[120px] flex items-center justify-center rounded-full drop-shadow-lg'>
              <p className='text-center'>Employee <br /> Engagements</p>
            </div>
            <div data-aos="zoom-in" data-aos-duration="1500" className='bg-[#f03359] w-[85px] h-[85px] flex items-center justify-center rounded-full drop-shadow-lg'>
                <p className=' text-center'>Annual <br /> Celebrations</p>
            </div>
          </div>

        </div>

    </div>
  )
}

export default OurServices
